<div class="input-wrapper">
  <vi-input-standalone
    class="flex-1"
    placeholder="{{ '+SERVICE_TOOL.BOILER_SERIAL_FIELD_TITLE' | translate }}"
    [errorMessage]="errorMessage"
    [showError]="serviceTicketStore.displayBoilerSerialError$ | async"
    [autocomplete]="true"
    [maxInputLength]="32"
    [autocompleteOptions]="devicesFromSearchResult"
    (inputFocus)="gtmService.track('onFocusTextField', 'Boiler serial', 'serviceTicket')"
    (inputBlur)="gtmService.track('onBlurTextField', 'Boiler serial', 'serviceTicket')"
    (valueChange)="valueChanged$.next($event)"
    [value]="boilerSerialAutoCompleteValue"
    [forceAutocompleteOpen]="devicesFromSearchResult.length > 1"
  ></vi-input-standalone>

  <button
    *ngIf="codeScannerService.isCodeScannerAvailable$ | async"
    class="scan-barcode-button"
    mat-icon-button
    gtm="onOpen"
    gtmAction="Barcode scanner"
    gtmCategory="serviceTicket"
    (click)="openScanner()"
  >
    <vi-icon name="barcode" [size]="32"></vi-icon>
  </button>
</div>

<mat-checkbox
  *ngIf="serviceTicketStore.displayBypassValidationCheckbox$ | async"
  data-at-terms-of-use-checkbox
  gtm="onToggle"
  gtmAction="Bypass boiler serial validation"
  gtmCategory="serviceTicket"
  [disabled]="isCheckboxDisabled"
  [(ngModel)]="serialValidBypassValue"
  (ngModelChange)="onSerialValidBypassChange($event)"
>
  {{ '+SERVICE_TOOL.BOILER_SERIAL_BYPASS_VALIDATION_TEXT' | translate }}
</mat-checkbox>
